/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Meta_Pagetitle1Inputs */

const ja_careers_meta_pagetitle1 = /** @type {(inputs: Careers_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAREERS`)
};

const en_careers_meta_pagetitle1 = /** @type {(inputs: Careers_Meta_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAREERS`)
};

/**
* | output |
* | --- |
* | "CAREERS" |
*
* @param {Careers_Meta_Pagetitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_meta_pagetitle1 = /** @type {((inputs?: Careers_Meta_Pagetitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Meta_Pagetitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_meta_pagetitle1(inputs)
	return en_careers_meta_pagetitle1(inputs)
});
export { careers_meta_pagetitle1 as "careers_meta_pageTitle" }